import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/system';
import Sidebar from './sidebar/Sidebar';
import Navbar from './header/Navbar';

type DrawerProps = {
    sidebarWidth: number;
};

const Drawer: React.FC<DrawerProps> = ({ sidebarWidth }) => {
    const [open, setOpen] = React.useState(false);
    const { pathname } = useLocation();

    const handleDrawerToggle = () => {
        setOpen(!open);
    };

    useEffect(() => {
        setOpen(false); // Close the navigation panel
    }, [pathname]);

    return (
        <Box className="flex" sx={{ bgcolor: 'var(--color-sidebar-background)' }}>
            <Sidebar sidebarWidth={sidebarWidth} toggler={handleDrawerToggle} isOpen={open} />
            <Navbar sidebarWidth={sidebarWidth} toggler={handleDrawerToggle} />
        </Box>
    );
};

export default Drawer;

